<template>
  <div class="w-full h-[0.5px] bg-gray-50"/>
</template>